import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, first } from 'rxjs/operators';

import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private contact = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) {
  }

  public updateContact = (id: string) => {
    var path = `/contact/${id}`
    return this.cms.request('GET', path).pipe(
      first(),
      map(body => {
        this.contact.next(body.data)
        return body.data
      })
    )
  }

  public getContact = (): Observable<any> => {
    return this.contact.asObservable()
  }

}
